import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

interface DeleteListingConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteListingConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: DeleteListingConfirmationModalProps) => {
  const initialFocusRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      trapFocus={true}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure you want to delete this listing?</Text>
        </ModalBody>
        <ModalFooter>
          <Flex gap={2}>
            <Button ref={initialFocusRef} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="primary" onClick={onConfirm}>
              Delete
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteListingConfirmationModal;
